import './AddressBlock.scss'

import React, {useContext, useState} from 'react'
import { TextField } from '@material-ui/core'
import useLang from 'src/hooks/useLang'
import SettingsContext from '#context/settings'
import Script from 'react-load-script'
import GoogleMaps from "#components/Google/GoogleAutocomplete";

const AddressBlock = props => {
  const { section, touched, errors, getFieldProps, requiredFields, getFieldValue, setFieldValue, setFieldTouched } = props
  const { settings } = useContext(SettingsContext)
  const lang = useLang(['address'])

  let fields = {
    zipCode: {},
    city: {},
    address: {},
    floorDoor: {},
    firstname: {},
    lastname: {},
    phone: {},
    email: {},
    phoneCountryCode: {},
    companyName: {},
    note: {},
  }

  let settingSection = 'pick_up';

  if (section === 'handover') {
    settingSection = 'handover';
  }

  if (settings.zip_code_input === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('zipCode');
  }

  if (settings[`${settingSection}_city_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('city');
  }

  if (settings[`${settingSection}_floor_door_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('floorDoor');
  }

  if (settings[`${settingSection}_first_name_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('firstname');
  }

  if (settings[`${settingSection}_last_name_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('lastname');
  }

  if (settings[`${settingSection}_phone_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('phone');
  }

  if (settings[`${settingSection}_email_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('email');
  }

  if (settings[`${settingSection}_company_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('companyName');
  }

  if (settings[`${settingSection}_note_input`] === 'REQUIRED' && requiredFields.length !== 0) {
    requiredFields.push('note');
  }

  let checkAutoFocus = true

  Object.keys(fields).map(key => {
    if (key != 'zipCode' || settings.zip_code_input !== 'HIDDEN') {
      fields[key].props = getFieldProps(section ? `${section}.${key}` : key)

      if (checkAutoFocus && !fields[key].props.value) {
        fields[key].props.autoFocus = true
        checkAutoFocus = false
      }
    }
  });

  return (
    <div className="AddressBlock">
      <div className="mb-20 flex line">
          {process.env.REACT_APP_USE_PLACES_API === "true" ? (
              <div className="flex-6 mr-10">
                <GoogleMaps
                    touched={touched}
                    errors={errors}
                    error={touched.address && !!errors.address}
                    helperText={touched.address && errors.address}
                    className="mr-10 flex-2"
                    fullWidth
                    fields={fields}
                    setFieldValue={setFieldValue}
                    getFieldValue={getFieldValue}
                    setFieldTouched={setFieldTouched}
                    section={section}
                    {...fields.address.props}
                    required={requiredFields?.includes('address')}
                />
              </div>
          ) : (
            <>
              <div className="flex mr-10 flex-6">
                {settings.zip_code_input !== 'HIDDEN' ? (
                  <TextField
                    className="mr-10 flex-2"
                    fullWidth
                    required={requiredFields.includes('zipCode')}
                    label={lang.address.zipCode}
                    error={touched.zipCode && !!errors.zipCode}
                    helperText={touched.zipCode && errors.zipCode}
                    {...fields.zipCode.props}
                  />
                ) : ''}

              <TextField
                className="flex-4"
                fullWidth
                required={requiredFields.includes('city')}
                label={lang.address.city}
                error={touched.city && !!errors.city}
                helperText={touched.city && errors.city}
                {...fields.city.props}
              />
        </div>
        <div className="flex-6 mr-10">
          <TextField
            fullWidth
            required={requiredFields.includes('address')}
            label={lang.address.address}
            error={touched.address && !!errors.address}
            helperText={touched.address && errors.address}
            {...fields.address.props}
          />
        </div>
            </>
        )}
        <div className="flex-3">
          <TextField
            fullWidth
            required={requiredFields.includes('floorDoor')}
            label={lang.address.floorDoor}
            {...fields.floorDoor.props}
          />
        </div>
      </div>
      <div className="mb-20 flex line">
        <div className="flex flex-2">
          <TextField
            className="mr-10 flex-1"
            fullWidth
            required={requiredFields.includes('firstname')}
            label={lang.address.firstname}
            {...fields.firstname.props}
          />
          <TextField
            className="flex-1"
            fullWidth
            required={requiredFields.includes('lastname')}
            label={lang.address.lastname}
            {...fields.lastname.props}
          />
        </div>
      </div>
      <div className="mb-20 flex line">
        <div className="flex flex-2">
          <TextField
            className="mr-10 flex-1"
            fullWidth
            label={lang.address.phone}
            required={requiredFields.includes('phone')}
            error={touched.phone && !!errors.phone}
            helperText={touched.phone && errors.phone}
            {...fields.phone.props}
          />
          <TextField
            className="flex-1"
            fullWidth
            label={lang.address.email}
            required={requiredFields.includes('email')}
            error={touched.email && !!errors.email}
            helperText={touched.email && errors.email}
            {...fields.email.props}
          />
        </div>
      </div>
      <div className="mb-20">
        <TextField
          className="flex-1"
          fullWidth
          label={lang.address.companyName}
          required={requiredFields.includes('companyName')}
          error={touched.companyName && !!errors.companyName}
          helperText={touched.companyName && errors.companyName}
          {...fields.companyName.props}
        />
      </div>
      <div className="flex">
        <TextField multiline={true} fullWidth label={lang.address.note} required={requiredFields.includes('note')} {...fields.note.props} />
      </div>
    </div>
  )
}

export default AddressBlock
